/**
 * Expedited Shipping Calculator
 * Calculates delivery date (today + 2 business days) and countdown to midnight EST
 */

class ExpeditedShipping {
  constructor() {
    this.deliveryDateEl = document.querySelector('.js-delivery-date');
    this.timeRemainingEl = document.querySelector('.js-time-remaining');
    
    if (!this.deliveryDateEl || !this.timeRemainingEl) return;
    
    this.init();
  }

  init() {
    // Set delivery date once
    this.updateDeliveryDate();
    
    // Update countdown immediately and then every minute
    this.updateCountdown();
    this.countdownInterval = setInterval(() => this.updateCountdown(), 60000); // Update every minute
  }

  /**
   * Get current date/time in EST timezone
   */
  getESTDate() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
  }

  /**
   * Calculate delivery date: today + 2 business days (excluding weekends)
   */
  calculateDeliveryDate() {
    const now = this.getESTDate();
    let deliveryDate = new Date(now);
    let daysAdded = 0;

    while (daysAdded < 2) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
      const dayOfWeek = deliveryDate.getDay();
      
      // Skip weekends (0 = Sunday, 6 = Saturday)
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        daysAdded++;
      }
    }

    return deliveryDate;
  }

  /**
   * Format date as "Mon 8th Sep"
   */
  formatDeliveryDate(date) {
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    
    const dayName = days[date.getDay()];
    const day = date.getDate();
    const month = months[date.getMonth()];
    
    // Add ordinal suffix (st, nd, rd, th)
    const suffix = this.getOrdinalSuffix(day);
    
    return `${dayName} ${day}${suffix} ${month}`;
  }

  /**
   * Get ordinal suffix for day number
   */
  getOrdinalSuffix(day) {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  /**
   * Calculate time remaining until midnight EST
   */
  calculateTimeRemaining() {
    const now = this.getESTDate();
    const midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    
    const diff = midnight - now;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    
    return `${hours}h ${minutes}m`;
  }

  /**
   * Update delivery date in DOM
   */
  updateDeliveryDate() {
    const deliveryDate = this.calculateDeliveryDate();
    const formattedDate = this.formatDeliveryDate(deliveryDate);
    this.deliveryDateEl.textContent = formattedDate;
  }

  /**
   * Update countdown in DOM
   */
  updateCountdown() {
    const timeRemaining = this.calculateTimeRemaining();
    this.timeRemainingEl.textContent = timeRemaining;
  }

  /**
   * Cleanup interval on destroy
   */
  destroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ExpeditedShipping();
  });
} else {
  new ExpeditedShipping();
}

